import { IAppState } from '@mafc/common';
import { useSelector } from 'react-redux';
import usePaymentV2Enabled from './usePaymentV2Enabled';
import EPaymentMethods from '../PamentMethods.enum';
import useLoyaltyThresholdReached from '../../LoyaltyPoints/hooks/useLoyaltyThresholdReached.hook';

const useLoyaltyNDiscount = () => {
  const { secondary, loading: isPaymentLoading } = useSelector(
    (state: IAppState) => state.checkout.payment
  );

  const { isWebPaymentArchitectureV2Enabled } = usePaymentV2Enabled();

  const isThresholdReached = useLoyaltyThresholdReached();

  const shouldShowLoyalty =
    ((isWebPaymentArchitectureV2Enabled && secondary.includes(EPaymentMethods.CASHBACK)) ||
      !isWebPaymentArchitectureV2Enabled) &&
    isThresholdReached;

  const shouldShowPromo =
    (isWebPaymentArchitectureV2Enabled && secondary.includes(EPaymentMethods.VOUCHER)) ||
    !isWebPaymentArchitectureV2Enabled;

  return {
    isPaymentLoading,
    shouldShowLoyalty,
    shouldShowPromo,
    shouldShowSection: shouldShowLoyalty || shouldShowPromo,
  };
};

export default useLoyaltyNDiscount;
